<template>
  <div class="home-nomina p-4">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-base">
        <vx-card class="card-actividades-control shadow-sm border border-slate-100">
          <div class="flex items-center gap-3 mb-4">
            <div class="icon-circle bg-primary text-white p-3 rounded-full flex items-center justify-center">
              <i class="feather icon-activity text-xl"></i>
            </div>
            <h5 class="font-bold text-slate-800 m-0">Actividades Control</h5>
          </div>

          <div class="table-rows space-y-2 mb-4 text-sm">
            <div class="flex justify-between items-center py-1.5 border-b border-slate-100">
              <span class="text-slate-500 font-medium">Tareas hoy</span>
              <span class="font-bold text-slate-800">{{ resumenActividades.tareasHoy }}</span>
            </div>
            <div class="flex justify-between items-center py-1.5 border-b border-slate-100">
              <span class="text-slate-500 font-medium">Pendientes</span>
              <span class="font-bold text-slate-800">{{ resumenActividades.pendientes }}</span>
            </div>
            <div class="flex justify-between items-center py-1.5 border-b border-slate-100">
              <span class="text-slate-500 font-medium">Validadas</span>
              <span class="font-bold text-slate-800">{{ resumenActividades.validadas }}</span>
            </div>
            <div class="flex justify-between items-center py-1.5">
              <span class="text-slate-500 font-medium">Este mes</span>
              <span class="font-bold text-slate-800">{{ resumenActividades.esteMes }}</span>
            </div>
          </div>

          <div class="mt-4">
            <vs-button color="primary" class="w-full" type="filled" :to="{ name: 'actividades-control' }">
              Ver Actividades
            </vs-button>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeNomina',
  props: {
    usuario: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      resumenActividades: {
        tareasHoy: 0,
        pendientes: 0,
        validadas: 0,
        esteMes: 0
      }
    }
  },
  mounted() {
    this.cargarResumenActividades()
  },
  methods: {
    async cargarResumenActividades() {
      try {
        const userObj = this.usuario && this.usuario.idusuario ? this.usuario : JSON.parse(localStorage.getItem('usuario'))
        const idusuario = userObj ? userObj.idusuario : null
        if (!idusuario) return
        
        const hoy = new Date().toISOString().split('T')[0]
        const primerDiaMes = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
        const ultimoDiaMes = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().split('T')[0]
        
        const response = await this.$http.get(this.$server_url + 'actividades-control/tareas', { params: { idusuario } })
        const todasTareas = response.data || []
        this.resumenActividades = {
          tareasHoy: todasTareas.filter(t => (t.fecha_tarea || '').substring(0, 10) === hoy).length,
          pendientes: todasTareas.filter(t => t.estado === 'pendiente').length,
          validadas: todasTareas.filter(t => t.estado === 'validada').length,
          esteMes: todasTareas.filter(t => {
            const f = (t.fecha_tarea || '').substring(0, 10)
            return f >= primerDiaMes && f <= ultimoDiaMes
          }).length
        }
      } catch (error) {
        console.error('Error al cargar resumen de actividades:', error)
      }
    }
  }
}
</script>

<style scoped>
.icon-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
}
</style>
